import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'app-overview-table',
  templateUrl: './overview-table.component.html',
  styleUrls: ['../../patient-profile/patient-profile.component.scss', './overview-table.component.scss']
})
export class OverviewTableComponent implements OnInit {

  @Input('id') id:any;
  data:any = {status:0, activities:[], allowNoteTags: false, sdtitle: "Symptoms & Diagnosis"};
  dept:any = "";
  consultant:any = "";
  limit:any = 40;
  recommended_therapies: string[] = [];
  selectedRemark:any = {
    category:"", 
    title:"", 
    consultant:"", 
    date:"",
    dept:"",
    tag:"",
    item:{
      id:0,
      title:"",
      contents:"",
      tags: []
    }
  };
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.loadOverview();
  }

  loadOverview(){
    this.dataService.getClientOverview(this.id, this.dept, this.consultant, this.limit ).subscribe( (data: any[] )=> {
      this.data = data;
      console.log(this.data);
    });
  }

  submitNotes(data){
    data.patient_id = this.id;
    data.tags = this.recommended_therapies;
    //data.date = $('#note-date').val();
    $('#btn-remarks').attr('disabled', 'true');
    $('#btn-remarks').text('Submitting');
    
    this.dataService.postNotes(data).subscribe( (res:any) => {
      if(res.status == 0) {
        alert(res.msg);
        $('#modalRemarks').modal('hide');
        $('#btn-remarks').text('Submit');
        this.recommended_therapies = [];
        this.loadOverview();
      } else {
        alert(res.msg);
      }


    });

    
    
  }

  loadRemarks(item){
    this.selectedRemark = item;
    $("#modalViewRemarks").modal("show");
    console.log(item);
  }

  addTherapy(value: string) {
    if (!value || value.trim() === '') return;
    
    // Split by comma if multiple therapies are entered
    const therapies = value.split(',').map(t => t.trim()).filter(t => t !== '');
    
    therapies.forEach(therapy => {
      if (!this.recommended_therapies.includes(therapy)) {
        this.recommended_therapies.push(therapy);
      }
    });
    
    // Clear input
    const input = document.getElementById('therapyInput') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  removeTherapy(therapy: string) {
    const index = this.recommended_therapies.indexOf(therapy);
    if (index > -1) {
      this.recommended_therapies.splice(index, 1);
    }
  }

}
